import { useMemo } from 'react'
import './progress.css'

type Props = {
    percentComplete: number | undefined
    completedRows?: number
    totalRows?: number
}

export default function Progress(props: Props) {
    const { percentComplete, completedRows, totalRows } = props
    const roundedPercent = useMemo(() => Number(percentComplete).toFixed(2), [percentComplete])

    return (
        <div className='pb-4'>
            <div className='flex'>
                <progress className='mt-1' value={percentComplete} max={100} />
                <span className='self-center'>
                    {roundedPercent}% Completion
                    {completedRows !== undefined && totalRows !== undefined && (
                        <span className='ml-2 text-gray-400'>
                            ({completedRows.toLocaleString()} / {totalRows.toLocaleString()} rows)
                        </span>
                    )}
                </span>
            </div>
        </div>
    )
}
